import { Box, Button, Flex, Input, Link, List, ListItem, Spinner } from "@chakra-ui/react";
import React, { useState } from "react";
import style from "./UploadUserExcel.module.css"
import { FaDownload } from "react-icons/fa";
import { getImageBaseUrl } from "../../Helper/env";
import { useBulkOpsJob } from "../../hooks/useBulkOpsJob";

interface companyObject { _id: string; companyName: string }

export const UploadUserExcel: React.FC<{ companyList: companyObject[]; onSuccess?: () => void }> = ({ companyList, onSuccess }) => {
    const [excelState, setExcelState] = useState<File | null>(null)
    const [selectedCompany, setSelectedCompany] = useState<string | null>(null)
    const [searchTerm, setSearchTerm] = useState<string>('')
    const [showOptions, setShowOptions] = useState<boolean>(false)
    const { isLoading, submit } = useBulkOpsJob('CREATE', 'Create_Users', onSuccess)

    const handleInputCompany = (companyId: string, companyName: string) => {
        setSelectedCompany(companyId); setSearchTerm(companyName); setShowOptions(false);
    }

    const filteredCompanies = companyList?.filter(c =>
        c.companyName.toLowerCase().includes(searchTerm.toLowerCase())
    ) || []

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        setExcelState(e.target?.files?.[0] || null)
    }

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        await submit(excelState, selectedCompany);
    }

    return (
        <Box alignItems={"center"}>
            <form className={style.excelForm} onSubmit={handleSubmit} encType="multipart/form-data">
                <Button type="submit" padding={"20px"} width={"200px"} colorScheme="green" isDisabled={isLoading}>
                    {isLoading === false && "Add Users"}
                    {isLoading && <Spinner thickness='4px' speed='0.65s' emptyColor='gray.200' color='blue.500' size='md' />}
                </Button>
                <Input type="file" onChange={handleInput} width={"250px"} accept=".csv" />
                <Box position="relative" w={"250px"}>
                    <Input placeholder="Search Partner Company" value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onFocus={() => setShowOptions(true)}
                        onBlur={() => setTimeout(() => setShowOptions(false), 200)}
                    />
                    {showOptions && filteredCompanies.length > 0 && (
                        <List position="absolute" top="100%" left={0} right={0} bg="white"
                            border="1px solid" borderColor="gray.200" borderRadius="md" maxH="200px" overflowY="auto" zIndex={10}>
                            {filteredCompanies.map((item) => (
                                <ListItem key={item._id} p={2} cursor="pointer" _hover={{ bg: "gray.100" }}
                                    onClick={() => handleInputCompany(item._id, item.companyName)}>
                                    {item.companyName}
                                </ListItem>
                            ))}
                        </List>
                    )}
                </Box>
                <Link href={`${getImageBaseUrl()}/azure/api/v1/signedUrl/get-public-document/others/Create_User_Template_V6.csv`}>
                    <Flex alignItems={"center"} gap={"10px"}><FaDownload color="green" /> Download Template</Flex>
                </Link>
            </form>
        </Box>
    )
}
